<template>
    <div id="paintwork-form-details-page">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                :action="cancel"
                icon="arrow-left"
                :label="trans('pages.paintwork_form_details.to_overview')" />
            <actions-menu-item
                :v4="true"
                :action="exportPaintworkform"
                icon="tag"
                :label="trans('pages.paintwork_form_details.export')" />
        </actions-menu>

        <div class="leftcolumn">
            <template v-if="paintworkorder && colors">
                <h1>
                    {{ trans('pages.paintwork_form_details.paintwork_order') }}
                    <span id="paintworkformdetailsid">
                        {{ paintworkorder.paintworkorderId }}
                    </span>
                </h1>
                <p class="paintworkformdetailspaintshop">
                    {{ trans('pages.paintwork_form_details.paint_shop') }}
                    {{
                        paintworkorder.paintshop
                            ? paintworkorder.paintshop.name
                            : ''
                    }}
                </p>
                <p class="paintworkformdetailsnumberofcolors">
                    {{ trans('pages.paintwork_form_details.number_of_colors') }}
                    {{
                        paintworkorder.numberOfColors
                            ? paintworkorder.numberOfColors
                            : ''
                    }}
                </p>
                <p class="paintworkformdetailsarea">
                    {{ trans('pages.paintwork_form_details.total_area') }}
                    {{
                        (paintworkorder.area ? paintworkorder.area : 0).toFixed(2) + ' m&#178;'
                    }}
                </p>
                <p class="paintworkformdetailsdate">
                    {{ trans('pages.paintwork_form_details.date') }} {{ paintworkorder.dateCreated }}
                </p>
                <div id="paintworkformdetailsdiv">
                    <div
                        v-for="color in colors"
                        class="paintworkformdetailscolor">
                        <div class="paintworkformdetailstitle">
                            <div class="titleelement titleleft">
                                {{ color.ral }}
                            </div>
                            <div class="titleelement titleleft">
                                {{ color.code }}
                            </div>
                            <div class="titleelement titleleft">
                                {{ color.producent }}
                            </div>
                            <div class="titleelement titleright">
                                {{ color.count }}x
                            </div>
                            <div class="titleelement titleright">
                                {{ (color.area ? color.area : 0).toFixed(2) }} m&#178;
                            </div>
                        </div>
                        <p>{{ trans('pages.paintwork_form_details.packages_in_this_color') }}</p>
                        <div class="paintworkformdetailspaintlists">
                            <div
                                class="paintworkformdetailspaintlist"
                                v-for="paintlist in color.paintlists">
                                <div
                                    class="search-div"
                                    @click="
                                        navigateToOptimizedPaintlistView(
                                            paintlist.ID
                                        )
                                    "
                                    align="center">
                                    <i class="material-icons">search</i>
                                </div>
                                <div
                                    class="paintworkformdetailspaintlistelement">
                                    {{ paintlist.ID }}
                                </div>
                                <div
                                    class="paintworkformdetailspaintlistelement">
                                    {{ paintlist.ral }}
                                </div>
                                <div
                                    class="paintworkformdetailspaintlistelement">
                                    {{ paintlist.poeder }}
                                </div>
                                <div
                                    class="paintworkformdetailspaintlistelement">
                                    {{ paintlist.merk }}
                                </div>
                                <div
                                    class="paintworkformdetailspaintlistelement">
                                    {{ (paintlist.area ? paintlist.area : 0).toFixed(2) }} m&#178;
                                </div>
                                <div
                                    class="paintworkformdetailspaintlistelement count">
                                    {{ paintlist.count }}
                                </div>
                            </div>
                            <br />
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import IdParamMixin from '../mixins/id-param';
import NavigationFunctionsMixin from '../mixins/navigation-functions';
import paintWorkOrderApi from '../api/paintWorkOrder';
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import { precisionRound } from '../helpers/MathHelper';
import localization from '../mixins/localization';

export default {
    mixins: [IdParamMixin(), NavigationFunctionsMixin, localization],
    components: {
        ActionsMenu,
        ActionsMenuItem,
    },
    data() {
        return {
            paintworkorder: null,
            colors: null,
        };
    },
    methods: {
        precisionRound,
        cancel() {
            this.$router.go(-1);
        },
        exportPaintworkform() {
            window.open(
                Config.url +
                '/export/exportPaintworkform/?paintworkformId=' +
                this.idParam,
                '_blank'
            );
        },
        load() {
            this.$store.commit(
                'general/setPageTitle',
                `${this.trans('pages.paintwork_form_details.details_paintwork_order')} ${this.idParam}`,
                { root: true }
            );

            paintWorkOrderApi.detail(this.idParam).then((response) => {
                const paintworkData = response.data.data;
                this.paintworkorder = paintworkData.paintworkorder;
                this.colors = paintworkData.colors;
            });
        },
    },
};
</script>
